import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    cta: 'Change my code',
    description:
      'After you change your PIN code, make a withdrawal in order to update your card.',
    help: 'Learn more about our pricing',
    title: 'Validate your PIN code with a simple withdrawal',
    warning:
      'Depending on your Shine subscription, you might be charged {0} for this cash withdrawal.',
  },
  fr: {
    cta: 'Changer mon code',
    description:
      'Une fois votre code PIN modifié, il vous suffira d’effectuer un retrait en distributeur pour le valider.',
    help: 'Plus d’informations sur nos tarifs',
    title: 'Un simple retrait pour valider votre code PIN',
    warning:
      'En fonction de votre abonnement, ce retrait pourra vous être facturé {0}\xa0HT.',
  },
} as const);

export default locales;
